import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from "react-redux"

import * as actions from "../actions/allActions"
import { NotificationPreferenceType } from '../helpers/NotificationPreferenceType'

import { PootsyCheckboxInput, PootsySelectInput } from "./InputsFunctions"
import InputsChangeHandler from "./InputsChangeHandler"
import { ExternalPrimaryLink, PootsyButton } from "./DesignFunctions"
import ModalLayout from "./shared/ModalLayout"


class AccountPrivacy extends Component {

	state = {
		notificationPreferences: {},
		showPrivacyActionConfirmation: false,
		privacyActionToExecute: null,
		chosenAffiliateID: "",
		showAffiliateRequired: false,
	}

	componentDidMount() {
		let { notificationPreferences } = this.props.user

		this.setState({
			notificationPreferences: {
				commercialPootsyEmail: notificationPreferences.find(pref => pref.type === NotificationPreferenceType.COMMERCIAL_POOTSY_EMAIL.name).enabled,
				commercialPootsyPush: notificationPreferences.find(pref => pref.type === NotificationPreferenceType.COMMERCIAL_POOTSY_PUSH.name).enabled,
				commercialAffiliate: notificationPreferences.find(pref => pref.type === NotificationPreferenceType.COMMERCIAL_AFFILIATE.name).enabled,
				communicationEmail: notificationPreferences.find(pref => pref.type === NotificationPreferenceType.COMMUNICATION_EMAIL.name).enabled,
				communicationPush: notificationPreferences.find(pref => pref.type === NotificationPreferenceType.COMMUNICATION_PUSH.name).enabled,
			}
		})
	}

	render() {
		return (
			<div className="AccountPrivacy">
				{this.state.showPrivacyActionConfirmation && this.renderPrivacyActionConfirmationModal()}
				{this.renderBlock('account_privacy_notifications_title', this.renderNotificationPreferences())}
				{this.renderBlock('account_privacy_terms_title', this.renderTerms())}

				{this.renderBlock(PrivacyAction.REMOVE_AFFILIATE_DATA.title, this.renderPrivacyAction(PrivacyAction.REMOVE_AFFILIATE_DATA))}
				{this.renderBlock(PrivacyAction.REMOVE_POOTSY_DATA.title, this.renderPrivacyAction(PrivacyAction.REMOVE_POOTSY_DATA))}
				{this.renderBlock(PrivacyAction.END_CONTRACT.title, this.renderPrivacyAction(PrivacyAction.END_CONTRACT))}
				{this.renderBlock(PrivacyAction.EXPORT_AFFILIATE_DATA.title, this.renderPrivacyAction(PrivacyAction.EXPORT_AFFILIATE_DATA))}
				{this.renderBlock(PrivacyAction.EXPORT_POOTSY_DATA.title, this.renderPrivacyAction(PrivacyAction.EXPORT_POOTSY_DATA))}
			</div>
		)
	}

	renderBlock = (titleKey, content) => {
		let { t } = this.context
		let { user: { scheduledJobs } } = this.props
		if (['privacy_action_remove_pootsy_data_title'].includes(titleKey)){
			if (scheduledJobs.some(entry => entry.job_type === "FORGET_POOTSY_CUSTOMER" )){
				return null
			}
		} else if(['privacy_action_remove_affiliate_data_title'].includes(titleKey)) {
			if (scheduledJobs.some(entry => entry.job_type === "DISABLE_CUSTOMER" )){
				return null
			}
		}
		return (
			<div className="AccountPrivacyBlock">
				<div className="title">{t(titleKey)}</div>
				{content}
			</div>
		)
	}

	renderNotificationPreferences = () => {
		let { t } = this.context

		return (
			<div className="AccountPrivacyNotificationPreferences">
				<InputsChangeHandler onChange={this.handleNotificationPreferencesChanges}>
					<div className="block affiliate-commercial-notifications">
						<div className="desc">{t('affiliate_commercial_notifications_description')}</div>
						<PootsyCheckboxInput
							label={t('commercial_affiliate')}
							name="commercialAffiliate"
							checked={this.state.notificationPreferences.commercialAffiliate}
						/>
					</div>
					<div className="block pootsy-commercial-notifications">
						<div className="desc">{t('pootsy_commercial_notifications_description')}</div>
						<PootsyCheckboxInput
							label={t('commercial_pootsy_email')}
							name="commercialPootsyEmail"
							checked={this.state.notificationPreferences.commercialPootsyEmail}
						/>
						<PootsyCheckboxInput
							label={t('commercial_pootsy_push')}
							name="commercialPootsyPush"
							checked={this.state.notificationPreferences.commercialPootsyPush}
						/>

					</div>
					<div className="block communication-notifications">
						<div className="desc">{t('communication_notifications_description')}</div>
						<PootsyCheckboxInput
							label={t('communication_email')}
							name="communicationEmail"
							checked={this.state.notificationPreferences.communicationEmail}
						/>

						<PootsyCheckboxInput
							label={t('communication_push')}
							name="communicationPush"
							checked={this.state.notificationPreferences.communicationPush}
						/>
					</div>
				</InputsChangeHandler>
				<PootsyButton text={t('save')} onClick={this.onSaveNotificationPreferencesButtonClick}/>
			</div>
		)
	}

	renderTerms = () => {
		let { t } = this.context
		return (
			<div className="AccountPrivacyTerms">
				{t('privacy_terms_description')} <ExternalPrimaryLink to="http://www.google.be" label={t('click_here')}/>
			</div>
		)
	}


	renderPrivacyAction = (privacyAction) => {
		let { t } = this.context
		return (
			<div className="AccountPrivacyAction">
				{t(privacyAction.description)}
				<PootsyButton
					text={t(privacyAction.buttonTitle)}
					onClick={() => {
						this.setState({ showPrivacyActionConfirmation: true, privacyActionToExecute: privacyAction })
					}}
				/>
			</div>
		)
	}

	handleAffiliateChange = e => {
		let { value } = e.target
		this.setState({ chosenAffiliateID: value })
	}

	renderPrivacyActionConfirmationModal = () => {
		let { affiliates } = this.props
		let { privacyActionToExecute, chosenAffiliateID, showAffiliateRequired } = this.state
		let { t } = this.context
		let content, action;
		switch(privacyActionToExecute.name){
			case 'remove_pootsy_data':
				action = this.removePootsyData
				break;
			case 'export_pootsy_data':
				action = this.exportPootsyData
				break;
			case 'end_contract':
				action = this.endContract
				content = <PootsySelectInput
					name="chosenAffiliateID"
					options={affiliates.map(entry => ({ value: entry.id, label: entry.name }))}
					defaultText={t('choose_affiliate')}
					selected={chosenAffiliateID}
					onChange={this.handleAffiliateChange}
					showRequired={showAffiliateRequired}
				/>
				break;
			case 'remove_affiliate_data':
				action = this.removeAffiliateData
				content = <PootsySelectInput
					name="chosenAffiliateID"
					options={affiliates.map(entry => ({ value: entry.id, label: entry.name }))}
					defaultText={t('choose_affiliate')}
					selected={chosenAffiliateID}
					onChange={this.handleAffiliateChange}
					showRequired={showAffiliateRequired}
				/>
				break;
			case 'export_affiliate_data':
				action = this.exportAffiliateData
				content = <PootsySelectInput
					name="chosenAffiliateID"
					options={affiliates.map(entry => ({ value: entry.id, label: entry.name }))}
					defaultText={t('choose_affiliate')}
					selected={chosenAffiliateID}
					onChange={this.handleAffiliateChange}
					showRequired={showAffiliateRequired}
				/>
				break;
			default:
				break;
		}
		return (
			<ModalLayout
				title={t('execute_privacy_action_confirmation_title')}
				closeModal={this.toggleModal}
				customClass="privacy-action-modal"
				contentClass="description"
				buttons={[
					<PootsyButton key="0" text={t("continue")} onClick={action}/>,
					<PootsyButton key="1" text={t("cancel")} theme="cancel" onClick={this.toggleModal}/>
				]}
			>
				{t(privacyActionToExecute.description)}
				<div className="content">
					{content}
				</div>
			</ModalLayout>
		)
	}

	toggleModal = () => {
		this.setState({
			showPrivacyActionConfirmation: !this.state.showPrivacyActionConfirmation,
			chosenAffiliateID: "",
			showAffiliateRequired: false,
		})
	}

	handleNotificationPreferencesChanges = (changes) => {
		let state = this.state
		state.notificationPreferences[Object.keys(changes)[0]] = changes[Object.keys(changes)[0]]
		this.setState(state)
	}

	onSaveNotificationPreferencesButtonClick = () => {
		this.props.dispatch(actions.saveAccountProfile(this.state.notificationPreferences))
	}

	removePootsyData = () => {
		let { dispatch } = this.props
		dispatch(actions.removePootsyData())
		this.toggleModal()
	}

	endContract = () => {
		let { dispatch } = this.props
		let { chosenAffiliateID } = this.state
		if(!chosenAffiliateID){
			this.setState({ showAffiliateRequired: true })
			return
		}
		dispatch(actions.endAffiliateContract(chosenAffiliateID))
		this.toggleModal()
	}

	exportPootsyData = () => {
		let { dispatch } = this.props
		dispatch(actions.fetchPootsyExport())
		this.toggleModal()
	}

	removeAffiliateData = () => {
		let { dispatch } = this.props
		let { chosenAffiliateID } = this.state
		if(!chosenAffiliateID){
			this.setState({ showAffiliateRequired: true })
			return
		}
		dispatch(actions.askAffiliateDataRemoval(chosenAffiliateID))
		this.toggleModal()
	}

	exportAffiliateData = () => {
		let { dispatch } = this.props
		let { chosenAffiliateID } = this.state
		if(!chosenAffiliateID){
			this.setState({ showAffiliateRequired: true })
			return
		}
		dispatch(actions.affiliateDataExport(chosenAffiliateID))
		this.toggleModal()
	}

}

const PrivacyAction = Object.freeze({
	REMOVE_AFFILIATE_DATA: {
		name: "remove_affiliate_data",
		title: 'privacy_action_remove_affiliate_data_title',
		description: 'privacy_action_ask_affiliate_data_description',
		buttonTitle: 'privacy_action_ask_affiliate_data_button_title',
	},
	REMOVE_POOTSY_DATA: {
		name: "remove_pootsy_data",
		title: 'privacy_action_remove_pootsy_data_title',
		description: 'privacy_action_remove_pootsy_data_description',
		buttonTitle: 'privacy_action_remove_pootsy_data_button_title',
	},
	END_CONTRACT: {
		name: "end_contract",
		title: 'privacy_action_end_contract_title',
		description: 'privacy_action_end_contract_description',
		buttonTitle: 'privacy_action_end_contract_button_title',
	},
	EXPORT_AFFILIATE_DATA: {
		name: "export_affiliate_data",
		title: 'privacy_action_export_affiliate_data_title',
		description: 'privacy_action_ask_export_affiliate_data_description',
		buttonTitle: 'privacy_action_ask_export_affiliate_data_button_title',
	},
	EXPORT_POOTSY_DATA: {
		name: "export_pootsy_data",
		title: 'privacy_action_export_pootsy_data_title',
		description: 'privacy_action_export_pootsy_data_description',
		buttonTitle: 'privacy_action_export_pootsy_data_button_title',
		action: actions.fetchPootsyExport,
	},
})

AccountPrivacy.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	user: state.dataReducer.currentUser,
	affiliates: state.dataReducer.userAffiliates,
})
export default connect(mapStateToProps)(AccountPrivacy);


// WEBPACK FOOTER //
// ./src/components/AccountPrivacy.js